import { createApp } from 'vue'
import PublicExhibitorsList from '@/components/public/PublicExhibitorsList.vue'

async function init() {
    // Check if we have exhibitors list configuration
    if (window.rvr_public && window.rvr_public.exhibitors_list_config) {
        const config = window.rvr_public.exhibitors_list_config;
        const containerId = config.instance_id || 'exhibitors-list-default';
        
        // Find the container element
        const container = document.getElementById(containerId);
        if (container) {
            const app = createApp(PublicExhibitorsList, {
                showContactInfo: config.show_contact_info || false,
                initialSortBy: config.initial_sort_by || 'company_name',
                initialSortOrder: config.initial_sort_order || 'asc'
            });
            
            app.mount(`#${containerId}`);
        }
    }
}

// Wait for DOM to be ready
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
} else {
    init();
}
